import {ValueDefinition} from '@/model/types';

export const enum Language {
  ENGLISH = 'DV-7#0',
  FRENCH = 'DV-7#1',
}

export const DV_7 = {
  id: 'DV-7',
  description: {
    fr: 'Langue',
    en: 'Language',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Anglais',
        en: 'English',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Français',
        en: 'French',
      },
    },
  ],
} as const satisfies ValueDefinition;
